module.exports = __webpack_public_path__ + "static/media/meet-piper-desktop-es.354034e2.svg";